import { get, getDownload, urlApiTegra } from "../../../service/api";

export const getDetailsTimesheetPoints = (token: string, query: string) => {
  return get(`${urlApiTegra}/time-points/addicional-hours${query}`, token);
};

function getTimePointDetailsDownload(
  userId: number, 
  dateFrom: string, 
  dateTo: string,
  token: string
) {
  const queryString = `?userId=${userId}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
  return getDownload(
    `${urlApiTegra}/time-point-details/download${queryString.trim()}`,
    token
    ).then((data) => data?.text());
}

export {
  getTimePointDetailsDownload,
};